import { createSelector } from "@ngrx/store";
import { PiDataState } from "../reducers/pi-data.reducer";
import { PiPoint } from "../../models/pi-data.model";

export const selectPiDataState = (state: any) => state.piData;

export const selectPiData = createSelector(
    selectPiDataState,
  (state: PiDataState) => state.piData
);

export const selectSelectedPiPoints = createSelector(
  selectPiDataState,
  (state: PiDataState) => state.selectedPiPoints
);

export const selectPiDataError = createSelector(
  selectPiDataState,
  (state: PiDataState) => state.error
);

export const selectPiPointValidation = createSelector(
  selectPiDataState,
  (state: PiDataState) => state.piPointValidation
);

export const selectPiPointSearchTerm = createSelector(
  selectPiPointValidation,
  (validation) => validation.searchTerm
);

export const selectPiPointSearchResults = createSelector(
  selectPiPointValidation,
  (validation) => validation.searchResults
);

export const selectPiPointIsSearching = createSelector(
  selectPiPointValidation,
  (validation) => validation.isSearching
);



export const selectPiPointSearchPerformed = createSelector(
  selectPiPointValidation,
  (validation) => validation.searchPerformed
);

export const selectIsLoadingPiPointsByRule = createSelector(
  selectPiDataState,
  (state: PiDataState) => state.isLoadingPiPointsByRule
);

export const selectPiPointValidationError = createSelector(
  selectPiPointValidation,
  (validation) => validation.error
);
// Selector to get unused selected PI points across all live codes
export const selectUnusedSelectedPiPointsGlobal = createSelector(
  selectSelectedPiPoints,
  selectPiDataState,
  (selectedPiPoints: PiPoint[], state: PiDataState) => {
    const allCode = Object.values(state.liveCodes || {}).join('\n');
    // Use the same extraction logic as in the component
    const patterns = [
      /df\s*\[\s*'([^']+)'\s*\]/g,
      /df\s*\[\s*"([^"]+)"\s*\]/g,
      /df\s*\[\s*`([^`]+)`\s*\]/g,
      /df\.\w+\s*\[[^,]+,\s*'([^']+)'\s*\]/g,
      /df\.\w+\s*\[[^,]+,\s*"([^"]+)"\s*\]/g,
      /df\.\w+\s*\[[^,]+,\s*`([^`]+)`\s*\]/g,
    ];
    const foundTags = new Set<string>();
    for (const pattern of patterns) {
      let match;
      while ((match = pattern.exec(allCode)) !== null) {
        if (match[1]) {
          foundTags.add(match[1].trim());
        }
      }
    }

    return selectedPiPoints
      .map(piPoint => piPoint.tag)
      .filter(
        (piTag) => !Array.from(foundTags).some((used) => used?.toUpperCase() === piTag?.toUpperCase())
      );
  }
);